var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpgradeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "upgrade-icon"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_21196_61459",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 56,
    height: 56
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 56,
    height: 56,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_21196_61459)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "upgrade",
    d: "M28.0001 36.6245C27.4296 36.6245 26.9557 36.4359 26.5785 36.0587C26.2013 35.6819 26.0127 35.208 26.0127 34.6371V16.1087L20.5842 21.5378C20.1875 21.9434 19.7234 22.1439 19.1918 22.1392C18.6602 22.1345 18.196 21.9341 17.7993 21.5378C17.4027 21.1411 17.2043 20.6793 17.2043 20.1524C17.2043 19.625 17.4027 19.1586 17.7993 18.7529L26.5937 9.95861C26.8068 9.74549 27.0292 9.59072 27.261 9.49427C27.4924 9.39783 27.7388 9.34961 28.0001 9.34961C28.2614 9.34961 28.5078 9.39783 28.7392 9.49427C28.971 9.59072 29.1934 9.74549 29.4065 9.95861L38.2008 18.7529C38.5975 19.1586 38.7958 19.6274 38.7958 20.1594C38.7958 20.691 38.5975 21.1504 38.2008 21.5378C37.8042 21.9434 37.34 22.1462 36.8084 22.1462C36.2768 22.1462 35.8127 21.9434 35.416 21.5378L29.9875 16.1087V34.6371C29.9875 35.208 29.7989 35.6819 29.4217 36.0587C29.0445 36.4359 28.5706 36.6245 28.0001 36.6245Z",
    fill: "#FFF9EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "upgrade_2",
    d: "M15.6179 46.4305C16.0299 46.8102 16.5474 47 17.1704 47H38.8296C39.4526 47 39.9701 46.8102 40.3821 46.4305C40.794 46.0512 41 45.5743 41 44.9997C41 44.4255 40.794 43.9486 40.3821 43.5689C39.9701 43.1896 39.4526 43 38.8296 43H17.1704C16.5474 43 16.0299 43.1896 15.6179 43.5689C15.206 43.9486 15 44.4255 15 44.9997C15 45.5743 15.206 46.0512 15.6179 46.4305Z",
    fill: "#FCBE1F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpgradeIcon);
export default __webpack_public_path__ + "static/media/upgradeIcon.b6700e654d61949db8749e02b0301620.svg";
export { ForwardRef as ReactComponent };